import { showPopover } from "@core-ui/showPopover";
import t from "@ext/localization/locale/translate";
import { Level, span, traced } from "@ext/loggers/opentelemetry";

export type CopyToClipboardOptions = {
	showPopover?: boolean;
	success?: string;

	showErrorPopover?: boolean;
	error?: string;
};

export const tryCopyToClipboard = async (
	text: string,
	opts: CopyToClipboardOptions = { showPopover: true, showErrorPopover: true },
): Promise<boolean> => {
	return await traced("tryCopyToClipboard", { level: Level.Commands, args: [text] }, async () => {
		try {
			await navigator.clipboard.writeText(text);
			if (opts?.showPopover || typeof opts?.showPopover !== "boolean")
				showPopover(opts?.success || t("share.popover"));

			return true;
		} catch (error) {
			span()?.recordException(error);
			if (opts?.showErrorPopover || typeof opts?.showErrorPopover !== "boolean")
				showPopover(opts?.error || t("share.error.failed-to-copy"));

			return false;
		}
	});
};

export const canCopyImageToClipboard = (): boolean =>
	typeof ClipboardItem !== "undefined" && typeof navigator !== "undefined" && !!navigator.clipboard?.write;

export const tryCopyImageToClipboard = async (png: Promise<Blob>): Promise<boolean> => {
	return await traced("tryCopyImageToClipboard", { level: Level.Commands }, async () => {
		try {
			// Safari drops the user activation across an await, so the blob goes in as a pending promise.
			await navigator.clipboard.write([new ClipboardItem({ "image/png": png })]);
			showPopover(t("image-copied"));
			return true;
		} catch (error) {
			span()?.recordException(error);
			showPopover(t("share.error.failed-to-copy"));
			return false;
		}
	});
};
